import { render } from "./RecursoConcha.vue?vue&type=template&id=cf989a90&scoped=true"
import script from "./RecursoConcha.vue?vue&type=script&lang=js"
export * from "./RecursoConcha.vue?vue&type=script&lang=js"

import "./RecursoConcha.vue?vue&type=style&index=0&id=cf989a90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf989a90"]])

export default __exports__